/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Toast_Signed_OutInputs */

const en_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed out.`)
};

const es_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión cerrada.`)
};

const de_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgemeldet.`)
};

const zh_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已退出。`)
};

const ar_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تسجيل الخروج.`)
};

const fr_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnecté.`)
};

const vi_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng xuất.`)
};

const sw_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umeondoka.`)
};

const th_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกจากระบบแล้ว`)
};

const bs_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odjavljeni ste.`)
};

const ja_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウトしました。`)
};

const ko_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃되었습니다.`)
};

const pt_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você saiu da conta.`)
};

const it_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnesso.`)
};

const sv_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har loggat ut.`)
};

const nl_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgemeld.`)
};

const da_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er logget ud.`)
};

const nb_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er logget ut.`)
};

const fi_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olet kirjautunut ulos.`)
};

const pl_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wylogowano.`)
};

const ru_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы вышли из аккаунта.`)
};

const tr_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış yapıldı.`)
};

const hi_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप लॉग आउट हो गए हैं।`)
};

const id_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda telah keluar.`)
};

const ms_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telah log keluar.`)
};

const cs_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odhlášeno.`)
};

const el_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποσυνδεθήκατε.`)
};

const he_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התנתקתם.`)
};

const af_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgeteken.`)
};

const hu_nav_toast_signed_out = /** @type {(inputs: Nav_Toast_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kijelentkezés sikeres.`)
};

/**
* | output |
* | --- |
* | "Signed out." |
*
* @param {Nav_Toast_Signed_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_toast_signed_out = /** @type {((inputs?: Nav_Toast_Signed_OutInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Toast_Signed_OutInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_toast_signed_out(inputs)
	if (locale === "de") return de_nav_toast_signed_out(inputs)
	if (locale === "zh") return zh_nav_toast_signed_out(inputs)
	if (locale === "ar") return ar_nav_toast_signed_out(inputs)
	if (locale === "fr") return fr_nav_toast_signed_out(inputs)
	if (locale === "vi") return vi_nav_toast_signed_out(inputs)
	if (locale === "sw") return sw_nav_toast_signed_out(inputs)
	if (locale === "th") return th_nav_toast_signed_out(inputs)
	if (locale === "bs") return bs_nav_toast_signed_out(inputs)
	if (locale === "ja") return ja_nav_toast_signed_out(inputs)
	if (locale === "ko") return ko_nav_toast_signed_out(inputs)
	if (locale === "pt") return pt_nav_toast_signed_out(inputs)
	if (locale === "it") return it_nav_toast_signed_out(inputs)
	if (locale === "sv") return sv_nav_toast_signed_out(inputs)
	if (locale === "nl") return nl_nav_toast_signed_out(inputs)
	if (locale === "da") return da_nav_toast_signed_out(inputs)
	if (locale === "nb") return nb_nav_toast_signed_out(inputs)
	if (locale === "fi") return fi_nav_toast_signed_out(inputs)
	if (locale === "pl") return pl_nav_toast_signed_out(inputs)
	if (locale === "ru") return ru_nav_toast_signed_out(inputs)
	if (locale === "tr") return tr_nav_toast_signed_out(inputs)
	if (locale === "hi") return hi_nav_toast_signed_out(inputs)
	if (locale === "id") return id_nav_toast_signed_out(inputs)
	if (locale === "ms") return ms_nav_toast_signed_out(inputs)
	if (locale === "cs") return cs_nav_toast_signed_out(inputs)
	if (locale === "el") return el_nav_toast_signed_out(inputs)
	if (locale === "he") return he_nav_toast_signed_out(inputs)
	if (locale === "af") return af_nav_toast_signed_out(inputs)
	if (locale === "hu") return hu_nav_toast_signed_out(inputs)
	return en_nav_toast_signed_out(inputs)
});